module.exports = __webpack_public_path__ + "img/camera-retro.fd42ba19.svg";